var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStartupListIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0192 4.12194C14.0192 -1.81287 0 0.243281 0 4.12194V8.79502C0 12.6737 3.13096 15.8046 7.00962 15.8046C10.8883 15.8046 14.0192 12.6737 14.0192 8.79502V4.12194Z",
    fill: "#08CC85"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4873 4.60815L6.09059 8.84625L3.99894 6.83007L2.80371 7.98218L6.09059 11.1505L11.6826 5.76026L10.4873 4.60815Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartupListIcon);
export default __webpack_public_path__ + "static/media/startup_list_icon.1e4eb05e06391f187b53700a319f81ff.svg";
export { ForwardRef as ReactComponent };